import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "invoiceStatus", "successMessage","paymentForm", "errorMessage","payNowBtn","invoicePayBtn"  ]

  connect() {

  }

  disconnect() {
  }
  
  checkout(event) {
	 event.preventDefault();
	 this.paymentFormTarget.style.display = "block";
	 card.focus();
  }
  
  pay_now(event) {
   event.preventDefault();
   this.errorMessageTarget.style.display = "none";
   this.payNowBtnTarget.innerHTML = "Processing your payment...";
   this.payNowBtnTarget.disabled = true;
   stripe.confirmCardPayment(this.data.get("secret"), {
    payment_method: {
      card: card,
    }
  }).then((result) => 
   {
	if (result.error) {
      // Show error to your customer (e.g., insufficient funds)
      this.errorMessageTarget.innerHTML = "We were unable to process your payment due to the following error: " + result.error.message;
      this.errorMessageTarget.style.display = "block";
      this.payNowBtnTarget.innerHTML = "Pay Now";
      this.payNowBtnTarget.disabled = false;
   
    } else {
      // The payment has been processed!
      if (result.paymentIntent.status === 'succeeded') {
	  this.invoiceStatusTarget.innerHTML = "PAID";
      this.successMessageTarget.innerHTML = "Payment Successful, Thank you!";
      this.successMessageTarget.style.display = "block";
      this.paymentFormTarget.style.display = "none";
      this.invoicePayBtnTarget.style.display ="none";
    } else {
	  this.errorMessageTarget.innerHTML = "We were unable to process your payment, please try again.";
      this.errorMessageTarget.style.display = "block";
      this.payNowBtnTarget.innerHTML = "Pay Now";
      this.payNowBtnTarget.disabled = false;
      }
    }
   
   } );   
  
 }
   

}

